import { SnippetUsage } from '../types';
import { getUsageGrid } from '../utils';

import { UsageRow } from './UsageRow';
import { UsageTableHeader } from './UsageTableHeader';
import { SnippetListSkeleton } from './SnippetListSkeleton';

type UsageTableProps = {
  results: SnippetUsage[];
  isLoading: boolean;
  isUpdating: boolean;
};

export const UsageTable = ({ results, isLoading, isUpdating }: UsageTableProps) => {
  const usageRowGrid = getUsageGrid();

  const snippetSkeletons = Array(10)
    .fill({})
    .map((skeleton, i) => (
      <SnippetListSkeleton
        key={`skeleton-${i}`}
        canManageSnippets={true}
        snippetRowGrid={usageRowGrid}
      />
    ));

  return (
    <div data-test="usage-table">
      <UsageTableHeader />
      {isLoading || isUpdating
        ? snippetSkeletons
        : results.map((result: SnippetUsage) => {
            return (
              <UsageRow key={`usage-${result.id}`} result={result} usageRowGrid={usageRowGrid} />
            );
          })}
    </div>
  );
};
